:host {
  display: block;
  font-family: var(--cms-base-font);
  padding-bottom: 0.5rem; /* TODO: Replace by spacing-50 */
}

@include price-font-sizes();

.prefix {
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-font-trade-gothic);
  text-transform: lowercase;
}

.price {
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-font-badhouse);
  display: inline-block; 
  font-size: var(--cms-price-font-size);
  line-height: var(--cms-price-line-height);
}


.unit {
  font-size: 0.875rem;
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-font-trade-gothic);
}

.bracket {
  font-weight: 700;
  color: var(--cms-semanticColors-buy-medium-text);
  display: block;
  font-family: TradeGothic;
  font-size: 1rem;
  line-height: 1rem;
}